import React, { useEffect, useState, useRef } from 'react';
import "../Styles/Upcoming_tour_content.css";
import api from '../Api.js';
import dayjs from 'dayjs';

// 🧩 Modal Component for Order Details
const OrderDetailsModal = ({ booking, onClose }) => {
  const invoiceRef = useRef();

  if (!booking) return null;

  // Generate passenger rows HTML
  const passengersHtml = booking.passengers
    ?.map(
      (p) => `
        <tr>
          <td>${p.name}</td>
          <td>${p.age}</td>
          <td>${p.type}</td>
        </tr>`
    )
    .join("");

  // 🖨️ Print only the invoice content
  const handlePrint = () => {
    const printContent = invoiceRef.current.innerHTML;
    const printWindow = window.open('', '', 'width=900,height=700');
    printWindow.document.write(`
      <html>
        <head>
          <title>Tour Booking Invoice</title>
          <style>
            body { font-family: sans-serif; padding: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .header h1 { margin: 0; }
            .card { border: 1px solid #eee; border-radius: 8px; padding: 20px; margin-bottom: 20px; }
            .card h2 { border-bottom: 1px solid #eee; padding-bottom: 10px; }
            table { width: 100%; border-collapse: collapse; }
            th, td { text-align: left; padding: 8px; border-bottom: 1px solid #ddd; }
            .total { font-size: 22px; font-weight: bold; text-align: right; margin-top: 30px; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button onClick={onClose} style={closeBtnStyle}>✕</button>

        {/* Invoice content wrapper */}
        <div ref={invoiceRef}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <img
              src="https://jayrajgroup.org/static/media/Jayraj_logo.716f0a8347827463477d.png"
              alt="Company Logo"
              style={{ width: 150, height: 100 }}
            />
            <div style={{ flex: 1, textAlign: "center" }}>
              <h1 style={{ margin: 0 }}>Tour Booking Invoice</h1>
              <p><strong>Invoice No:</strong> {booking.invoice_no}</p>
            </div>
            <div style={{ width: 150 }}></div>
          </div>

          <div style={cardStyle}>
            <h2>Tour Details</h2>
            <p><strong>{booking.tour.title}</strong></p>
            <p><strong>Destination:</strong> {booking.tour.destination.name}</p>
            <p><strong>From:</strong> {dayjs(booking.tour_start_date).format("D MMM YYYY, h:mm a")}</p>
            <p><strong>To:</strong> {dayjs(booking.tour_end_date).format("D MMM YYYY, h:mm a")}</p>
            <hr />
            <p><strong>Booking Date:</strong> {dayjs(booking.created_at).format("D MMM YYYY, h:mm a")}</p>
            <p>
              <strong>Status:</strong>{" "}
              <span style={{ textTransform: "capitalize", color: "#23CE5F" }}>
                {booking.status}
              </span>
            </p>
            <hr />
          </div>

          <div style={cardStyle}>
            <h2>Passengers</h2>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody dangerouslySetInnerHTML={{ __html: passengersHtml }} />
            </table>
          </div>

          <div style={{ fontSize: 22, fontWeight: "bold", textAlign: "right", marginTop: 20 }}>
            Total Amount Paid: ₹{booking.paid_amount.toLocaleString("en-IN")}
          </div>
        </div>

        {/* 🖨️ Print Button */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
          <button
            onClick={handlePrint}
            style={{
              padding: "10px 20px",
              backgroundColor: "#d48e0bff",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            🖨️ Print Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

// Inline styles for modal
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  background: "#fff",
  borderRadius: 10,
  padding: 30,
  width: "80%",
  maxHeight: "90vh",
  overflowY: "auto",
  position: "relative",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
};

const closeBtnStyle = {
  position: "absolute",
  top: 15,
  right: 15,
  background: "transparent",
  border: "none",
  fontSize: 22,
  cursor: "pointer",
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: 8,
  padding: 20,
  marginBottom: 20,
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

// 🧭 Main Component
function Upcoming_tour_content() {
  const [upcomingTours, setUpcomingTours] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    const fetchUpcomingTours = async () => {
      try {
        const response = await api.get('/user/bookings/paid', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
        });
        console.log("upcoming tour data: ",response.data)
        if (response.data.success === true) {
          setUpcomingTours(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching upcoming tours:', error);
      }
    };
    fetchUpcomingTours();
  }, []);

  const upCommingTours = upcomingTours.filter((tour) =>
    dayjs(tour?.tour_end_date).isAfter(dayjs())
  );

  const formatDate = (date) => dayjs(date).format("D MMM h:mm a");

  return (
    <div className="upcoming_tour_content">
      {upCommingTours.map((tour) => (
        <div className="tripCard_wrapper" key={tour.id}>
          <div className="tripCard_image">
            <img src={tour?.tour?.destination?.image} alt={tour?.tour?.title} />
          </div>
          <div className="tripCard_content">
            <h2 className="tripCard_title">{tour?.tour?.title}</h2>
            <p className="tripCard_date" style={{ margin: 1 }}>
              {`${formatDate(tour?.tour_start_date)} - ${formatDate(tour?.tour_end_date)}`}
            </p>
            <p className="tripCard_date" style={{ margin: 4, fontWeight: "600" }}>
             Paid Amount: ₹{tour?.paid_amount}
            </p>
            <div className="tripCard_buttons">
              <button
                className="tripCard_btnDetails"
                onClick={() => setSelectedBooking(tour)}
              >
                Order details
              </button>
              <button className="tripCard_btnCancel">Cancel</button>
            </div>
          </div>
        </div>
      ))}

      {/* Modal Overlay */}
      {selectedBooking && (
        <OrderDetailsModal
          booking={selectedBooking}
          onClose={() => setSelectedBooking(null)}
        />
      )}
    </div>
  );
}

export default Upcoming_tour_content;
